import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { useEffect } from 'react'

type ProcessingLevels = Array<ItemType>

class ProcessingLevelsFilterDataBox extends DataBox<ProcessingLevels> {}

export const defaultProcessingLevels: ProcessingLevels = [
  {
    id: 'ready',
    title: 'Готовая продукция',
  },
  {
    id: 'raw',
    title: 'Сырье',
  },
]
export const processingLevelsFilter = createDataBox(
  'processingLevelsFilter',
  defaultProcessingLevels,
  ProcessingLevelsFilterDataBox,
)

export const defaultProcessingLevelsSelection: Array<string> = []
export const processingLevelsFilterSelection = createDataBoxDefault<Array<string>>(
  'processingLevelsFilterSelection',
  defaultProcessingLevelsSelection,
)

export const ProcessingLevelFilter = () => {
  useEffect(() => {
    processingLevelsFilter.setStatusReady()
    return () => {
      processingLevelsFilter.resetToDefault()
      processingLevelsFilterSelection.resetToDefault()
    }
  }, [])

  return (
    <PlainItemsSelectorBox
      id="processingLevel"
      label="Состояние продукции"
      header="Выбор состояния продукции"
      pleaseSelectText="Выберите состояние продукции"
      dataBoxData={processingLevelsFilter}
      dataBoxSelection={processingLevelsFilterSelection}
      multiple
      colorInverse
      wide
    />
  )
}
